module.exports = __webpack_public_path__ + "assets/img/1.ad3e7ef8.png";